module.exports = __webpack_public_path__ + "res/24-img_info_m.6d9276bb6ac11a6d17fdce495ff7c510.png";